import {
  LoyaltyCustomerInfo,
  LoyaltyTierSystemMilestone,
  LoyaltyTierSystemTier,
} from "../loyaltyTypes";

export const sortMilestonesByPoints = (
  milestones: LoyaltyTierSystemMilestone[]
): LoyaltyTierSystemMilestone[] =>
  [...milestones].sort(
    (a, b) => a.points - b.points || a.milestoneId.localeCompare(b.milestoneId)
  );

export const getAvailableMilestoneOfferIds = (
  customerInfo: LoyaltyCustomerInfo | null | undefined
): Map<string, Set<string>> => {
  const availableMilestones =
    customerInfo?.tierProgress?.availableMilestones ?? [];

  return new Map(
    availableMilestones.map((milestone) => [
      milestone.milestoneId,
      new Set(milestone.availableOffers),
    ])
  );
};

export const getVisibleMilestones = ({
  currentTier,
  customerInfo,
}: {
  currentTier?: LoyaltyTierSystemTier;
  customerInfo?: LoyaltyCustomerInfo | null;
}): LoyaltyTierSystemMilestone[] => {
  const tierMilestones = currentTier?.milestones ?? [];
  const availableMilestoneMap = getAvailableMilestoneOfferIds(customerInfo);

  if (availableMilestoneMap.size === 0) {
    return sortMilestonesByPoints(tierMilestones);
  }

  return sortMilestonesByPoints(
    tierMilestones.filter((milestone) =>
      availableMilestoneMap.has(milestone.milestoneId)
    )
  );
};

export const orderMilestonesForDisplay = <
  T extends { points: number; pointsToUnlock: number; isUnlocked: boolean }
>(
  milestones: T[]
): T[] => [
  ...milestones
    .filter((milestone) => milestone.isUnlocked)
    .sort((a, b) => b.points - a.points),
  ...milestones
    .filter((milestone) => !milestone.isUnlocked)
    .sort((a, b) => b.pointsToUnlock - a.pointsToUnlock),
];

export const getPointsToUnlock = ({
  milestonePoints,
  availablePoints,
}: {
  milestonePoints: number;
  availablePoints: number;
}): number => Math.max(0, milestonePoints - availablePoints);
